import { Col, Row } from "react-bootstrap";
import TotalRateEligibility from "./components/TotalRateEligibility";
import TotalRatePreauthorization from "./components/TotalRatePreauthorization";
import EligibilityInsuranceVolumn from "./components/EligibilityInsuranceVolumn";
import EligibilityInsuranceSummary from "./components/EligibilityInsuranceSummary";
import PreauthorizationInsuranceSummary from "./components/PreauthorizationInsuranceSummary";
import PreAuthorizationStatusDistribution from "./components/PreAuthorizationStatusDistribution";
import PreAuthApprovalRateChart from "./components/PreAuthApprovalRateChart";
import PreAuthVolumeChart from "./components/PreAuthVolumeChart";
import PreauthorizationVolumn from "./components/PreauthorizatiionInsuranceVolumn";
import MainDashboardFilter from "./components/MainDashboardFilter";
import DashboardStats from "./components/DashboardStats";
import { useForm } from "react-hook-form";
import moment from "moment";
import { GetAllGeneralDashboard } from "./config/dashboardApi";
import { handleDashboardFilter } from "./config/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import PreAuthRejectionReason from "./components/PreAuthRejectionReason";
import CommunicationTracker from "./components/CommunicationTracker";

const DashboardMain = () => {
  const dispatch = useDispatch();
  const { dashboardFilters } = useSelector((state) => state.dashboard);
  const { watch, setValue, control, handleSubmit } = useForm({
    defaultValues: {
      branches: [],
      payer: "",
      date: "",
    },
  });

  const branchesValue = dashboardFilters.branches || [];
  const branch_id =
    branchesValue
      .map((item) => item?.branch_id)
      .filter(Boolean)
      .join(",") || "";
  const dateValue = dashboardFilters.date || [];
  const frm_date = dateValue[0]
    ? moment(dateValue[0]).format("DD-MM-YYYY")
    : null;
  const to_date = dateValue[1]
    ? moment(dateValue[1]).format("DD-MM-YYYY")
    : dateValue[0]
      ? moment(dateValue[0]).format("DD-MM-YYYY")
      : null;

  const payerValue = dashboardFilters.payer;
  const payer_id = Array.isArray(payerValue)
    ? payerValue.map((item) => item.payer_id).join(",")
    : payerValue?.payer_id || "";

  const onFilterSubmit = () => {
    dispatch(
      GetAllGeneralDashboard({
        branch_id,
        frm_date,
        to_date,
        payer_id,
      })
    );
  };

  useEffect(() => {
    // Initialize branches with the login/default selected branch only once on mount
    try {
      const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
      const selectedBranchId = selectedBranch?.value || selectedBranch?.branch_id;
      const selectedBranchName = selectedBranch?.label || selectedBranch?.branch_name;
      const selectedBranchCchi =
        selectedBranch?.branch_cchi ||
        selectedBranch?.branch_cchino ||
        selectedBranch?.cchi;

      if (
        selectedBranchId &&
        (!dashboardFilters.branches || dashboardFilters.branches.length === 0)
      ) {
        const value = [
          {
            branch_id: selectedBranchId,
            branch_name: selectedBranchName,
            cchi: selectedBranchCchi,
          },
        ];
        dispatch(handleDashboardFilter({ check: "branches", value }));
      }
    } catch (_) { }
  }, [dispatch]); // Only run once on mount, not when branches change

  // Watch for branch changes and handle initial load
  useEffect(() => {
    let lastBranchId = null;
    let isInitialLoad = true;

    const checkBranchChange = () => {
      try {
        const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
        const currentBranchId = selectedBranch?.value || selectedBranch?.branch_id;

        // If branch changed (or initial load) and we have a valid branch ID
        if (currentBranchId && (currentBranchId !== lastBranchId || isInitialLoad)) {
          lastBranchId = currentBranchId;
          isInitialLoad = false;

          // Update dashboard filters with the new branch
          const selectedBranchName = selectedBranch?.label || selectedBranch?.branch_name;
          const selectedBranchCchi = selectedBranch?.branch_cchi || selectedBranch?.branch_cchino || selectedBranch?.cchi;

          const value = [
            {
              branch_id: currentBranchId,
              branch_name: selectedBranchName,
              cchi: selectedBranchCchi,
            },
          ];
          dispatch(handleDashboardFilter({ check: "branches", value }));

          // Fetch data with the new branch ID
          dispatch(
            GetAllGeneralDashboard({
              branch_id: currentBranchId,
              frm_date,
              to_date,
              payer_id,
            })
          );
        }
      } catch (error) {
        console.error("Error checking branch change:", error);
      }
    };

    // Check immediately for initial load
    checkBranchChange();

    // Set up interval to check for changes
    const interval = setInterval(checkBranchChange, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Row className="p-2">
      <Col xs={12}>
        <MainDashboardFilter
          watch={watch}
          control={control}
          setValue={setValue}
          onFilter={handleSubmit(onFilterSubmit)}
        />
      </Col>
      <Col xs={12}>
        <DashboardStats />
      </Col>
      <TotalRateEligibility />
      <TotalRatePreauthorization />
      <PreAuthRejectionReason />
      <CommunicationTracker />
      <PreAuthApprovalRateChart />
      {/* <PreAuthVolumeChart /> */}
      {/* <PreauthorizationInsuranceSummary /> */}
      {/* <PreauthorizationVolumn /> */}
      {/* <EligibilityStatusDistribution /> */}
      {/* <PreAuthorizationStatusDistribution /> */}
    </Row>
  );
};

export default DashboardMain;
